import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./datepicker.css";

function DatePicker({ ...props }) {
  return <ReactDatePicker {...props} />;
}

export default DatePicker;
